/** @format */

const MeetingEntriesModal = ({activeEntryView, onClose, getRoundDisclaimerText, entriesLoading, eventEntriesList}) => {
	// Standardize object properties to match CamelCase DB naming rules
	const targetDiscipline = activeEntryView?.disciplineName || activeEntryView?.discipline_name || activeEntryView?.activity || "—";
	const targetAgeClass = activeEntryView?.ageClass || activeEntryView?.age_class || activeEntryView?.class || "Open";
	const rawGender = activeEntryView?.sexCode || activeEntryView?.sex_code || activeEntryView?.gender || "Mixed";
	const targetRound = activeEntryView?.phaseTypeName || activeEntryView?.round || "Final";
	const totalEntriesCount = activeEntryView?.totalEntries || activeEntryView?.total_entries || 0;

	// Human-readable typography normalization for UI Presentation Header
	const getReadableGender = (genderStr) => {
		const clean = String(genderStr).trim().toLowerCase();
		if (["m", "male", "men", "boy"].includes(clean)) return "Male";
		if (["f", "female", "women", "girl"].includes(clean)) return "Female";
		return "Mixed";
	};

	const targetGender = getReadableGender(rawGender);

	return (
		<div className="amm-modal-overlay d-flex align-items-center justify-content-center p-3 animate__animated animate__fadeIn animate__fast" style={{position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(15, 23, 42, 0.65)", zIndex: 1050}}>
			<div className="card shadow-lg border-0 rounded-4 overflow-hidden w-100 animate__animated animate__zoomIn animate__fast" style={{maxWidth: "650px"}}>
				<div className="card-header bg-dark text-white p-3 border-0 d-flex justify-content-between align-items-center">
					<div>
						<h5 className="mb-0 fw-bold d-flex align-items-center text-light gap-2 fs-6">
							<i className="fas fa-medal text-warning"></i>
							{targetDiscipline} — {targetAgeClass} ({targetGender})
						</h5>
						<span className="badge bg-primary text-uppercase font-size-xs mt-1 px-2 py-1 fw-bold">{targetRound}</span>
					</div>
					<button className="btn-close btn-close-white shadow-none" onClick={onClose}></button>
				</div>
				<div className="card-body p-4" style={{maxHeight: "420px", overflowY: "auto"}}>
					<div className="alert alert-secondary bg-secondary bg-opacity-10 border border-secondary border-opacity-20 rounded-3 d-flex align-items-center gap-2 mb-4 p-3 text-secondary">
						<i className="fas fa-info-circle fa-lg flex-shrink-0"></i>
						<div className="small fw-semibold">{typeof getRoundDisclaimerText === "function" ? getRoundDisclaimerText(totalEntriesCount) : `Total Entries: ${totalEntriesCount}`}</div>
					</div>
					<div className="mb-2.5">
						<h6 className="fw-bold text-secondary text-uppercase font-size-xs tracking-wider mb-0">Registered Athletes</h6>
					</div>
					{entriesLoading ? (
						<div className="text-center py-5">
							<div className="spinner-border text-primary" role="status"></div>
							<p className="text-muted small mt-2 mb-0">Compiling active declaration lists...</p>
						</div>
					) : eventEntriesList && eventEntriesList.length > 0 ? (
						<div className="table-responsive border rounded-3">
							<table className="table table-striped table-hover align-middle mb-0 small">
								<thead className="table-light text-secondary font-weight-bold">
									<tr>
										<th className="ps-3" style={{width: "50px"}}>
											#
										</th>
										<th>Competitor Athlete</th>
										<th>Affiliation Club / Country</th>
										<th className="pe-3 text-end" style={{width: "100px"}}>
											Seed Mark
										</th>
									</tr>
								</thead>
								<tbody>
									{eventEntriesList.map((entry, idx) => {
										const fName = entry.firstName || entry.first_name || "";
										const mName = entry.middleName || entry.middle_name || "";
										const lName = entry.lastName || entry.last_name || "";
										const clubDisplay = entry.clubName || entry.club_name || entry.club || "Independent";
										const seedMarkDisplay = entry.seedMark || entry.seed_mark || "NT";

										return (
											<tr key={idx}>
												<td className="ps-3 fw-bold text-muted">{idx + 1}</td>
												<td className="fw-bold text-dark">
													{fName} {mName ? mName + " " : ""}
													<span className="text-uppercase">{lName}</span>
												</td>
												<td className="text-normal text-muted">{clubDisplay}</td>
												<td className="pe-3 text-end fw-mono font-monospace text-muted">{seedMarkDisplay}</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					) : (
						<div className="text-center py-5 bg-light rounded border border-dashed">
							<i className="fas fa-folder-open text-muted fa-2x mb-2"></i>
							<p className="text-dark fw-medium mb-1">No Declarations Confirmed</p>
							<p className="text-muted small mb-0">No entries have been filed yet for this competition class.</p>
						</div>
					)}
				</div>
				<div className="card-footer bg-light d-flex justify-content-end py-2 border-top">
					<button className="btn btn-sm btn-secondary font-weight-bold px-3" onClick={onClose}>
						Close View
					</button>
				</div>
			</div>
		</div>
	);
};

export default MeetingEntriesModal;
